'use strict';

(function () {
    'use strict';

    angular.module('user.selectionUsers', ['ui.router', 'common']);
})();